import clsx from 'clsx';
import { FC } from 'react';
import { PostPublication } from '../../../telegram-forum/model';

const STATUS_LABEL: Record<string, string> = {
	pending: 'Публикуется',
	sent: 'Опубликовано',
	failed: 'Ошибка',
};

/**
 * Состояние публикации поста в Telegram. Статус приходит вместе со списком,
 * отдельной ручки на строку не нужно.
 */
export const PostPublicationCell: FC<{
	publication?: PostPublication | null;
}> = ({ publication }) => {
	if (!publication?.status) {
		return <span className='text-muted'>—</span>;
	}

	return (
		<span
			className={clsx('badge fs-7', {
				'badge-light-success': publication.status === 'sent',
				'badge-light-warning': publication.status === 'pending',
				'badge-light-danger': publication.status === 'failed',
			})}
			title={publication.last_error || undefined}
		>
			{STATUS_LABEL[publication.status] || publication.status}
		</span>
	);
};
